<div class="container-fluid mt-2 header-new">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <div class="d-flex">
      <button mat-icon-button class="me-1" (click)="openDrawer()">
        <img src="assets/images/icons/menu-orange.png" alt="menu-icon" />
      </button>
    </div>

    <!-- Right block -->
    <div class="d-flex align-items-center flex-wrap gap-3">
      <div class="me-0"  [ngStyle]="{ 'display': isDropdownDisabled ? 'none' : 'block' }">

        <!-- Locations -->
        <mat-form-field *ngIf="parentTenant == 'pl'">
          <mat-select class="form-control matselect switch-select" [disabled]="isDropdownDisabled" (selectionChange)="changeTenant($event.value)" [(ngModel)]="multiTenant">
            <mat-option *ngIf="multiTenant != 'pl_qc'" value="pl">Pillway</mat-option>
            <mat-option *ngIf="multiTenant == 'pl_qc'" value="pl_qc">Pillway</mat-option>
            <mat-option *ngIf="multiTenant != 'qc'" value="sl">Sun Life</mat-option>
            <mat-option *ngIf="multiTenant == 'qc'" value="qc">Sun Life</mat-option>
            <mat-option *ngIf="multiTenant != 'ml_qc'" value="ml">Manulife</mat-option>
            <mat-option *ngIf="multiTenant == 'ml_qc'" value="ml_qc">Manulife</mat-option>
            <mat-option value="wylo">Wylo</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field *ngIf="parentTenant == 'qc'">
          <mat-select class="form-control matselect switch-select" [disabled]="isDropdownDisabled" (selectionChange)="changeTenant($event.value)" [(ngModel)]="multiTenant">
           <!--  <mat-option value="pl_qc">Pillway</mat-option> -->
            <mat-option  value="qc">Sun Life</mat-option>
            <mat-option  value="ml_qc">Manulife</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="me-0" *ngIf="isDropdownDisabled">
        <mat-form-field>
          <mat-select class="form-control matselect switch-select" [(ngModel)]="defaultValue" [disabled]="isDropdownDisabled">
            <mat-option *ngIf="isDropdownDisabled" [value]="1">{{ lodingText }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
     <!--  <div *ngIf="multiTenantShow"> -->
      <div>
        <mat-form-field>
        <mat-select class="form-control matselect switch-select" [disabled]="isDropdownDisabled" placeholder="Please Select"
          (selectionChange)="serverLocationChange($event.value)" [(ngModel)]="serverLocationVal">
          <mat-option *ngFor="let item of locations" [value]="item.id">
            {{ item.state_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      </div>


      <div class="d-flex align-items-center flex-wrap">
        <!-- Messages-notifications block -->
      <button mat-icon-button class="mx-1 position-relative my-1 my-md-0" [matMenuTriggerFor]="menuMsgNotificatons">
        <img src="assets/images/notifications/othersNotify.svg" alt="notification-inactive-icon" />
        <span *ngIf="adminNotification.length > 0" class="badge">{{ adminMsgNotificaton.length > 99 ? '99+' : adminMsgNotificaton.length }}
        </span>
      </button>
      <mat-menu #menuMsgNotificatons="matMenu" class="mat-menu-notifications p-0">
        <div class="p-2 bg-orange text-light">Other Notification</div>
        <div class="notifications">
          <div *ngFor="let item of adminMsgNotificaton; let i = index"
            class="d-flex align-items-center border-bottom p-2" (click)="$event.stopPropagation()">
            <img src="../../../../assets/images/notifications/notification_card_active_icon.png"
              alt="notification_card_active_icon" class="me-3" />
            <div>
              <div>
                <a class="link mt-2 mt-md-0 cursor-pointer" (click)="reRoute(item.user_id, item.type)">
                  {{ item.title }}
                </a>
              </div>
              <div class="text-muted">
                <a (click)="onCheckChangeAdminNotification(item)" class="link mt-2 mt-md-0 cursor-pointer">
                  <img src="../../../assets/images/check_box.png" class="me-1" alt="check_box icon" />Acknowledge
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-primary" routerLink="/portal/msg-notifications">
          <button mat-button class="view_all">View All</button>
        </div>
      </mat-menu>

      <!-- admin notification block -->
      <button mat-icon-button class="mx-1 position-relative my-1 my-md-0" [matMenuTriggerFor]="menuAdminNotification">
        <img src="assets/images/notifications/family-notification.svg" alt="notification-inactive-icon" />
        <span *ngIf="adminNotification.length > 0" class="badge">{{ adminNotification.length > 99 ? '99+' : adminNotification.length }}
        </span>
      </button>
      <mat-menu #menuAdminNotification="matMenu" class="mat-menu-notifications">
        <div class="p-2 bg-orange text-light">Notifications</div>
        <div class="notifications">
          <div *ngFor="let item of adminNotification; let i = index" class="d-flex align-items-center border-bottom p-2"
            (click)="$event.stopPropagation()">
            <img src="../../../../assets/images/notifications/notification_card_active_icon.png"
              alt="notification_card_active_icon" class="me-3" />
            <div>
              <div>
                <a class="link mt-2 mt-md-0 cursor-pointer" (click)="reRoute(item.user_id, item.type)">
                  {{ item.title }}
                </a>
              </div>
              <div class="text-muted">
                <a (click)="onCheckChangeAdminNotification(item)" class="link mt-2 mt-md-0 cursor-pointer">
                  <img src="../../../assets/images/check_box.png" class="me-1" alt="check_box icon" />Acknowledge
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-primary" routerLink="/portal/admin-notifications">
          <button mat-button class="view_all">View All</button>
        </div>
      </mat-menu>

      <!-- order notification -->

      <button mat-icon-button class="mx-1 position-relative my-1 my-md-0" [matMenuTriggerFor]="menuOrderNotification">
        <img src="assets/images/notifications/Orders.svg" alt="notification-inactive-icon" />
        <span *ngIf="orderNotification.length > 0" class="badge">{{ orderNotification.length > 99 ? '99+' : orderNotification.length }}</span>

      </button>
      <mat-menu #menuOrderNotification="matMenu" class="mat-menu-notifications">
        <div class="p-2 bg-orange text-light">Order Notifications</div>
        <div class="notifications">
          <div *ngFor="let item of orderNotification; let i = index" class="d-flex align-items-center border-bottom p-2"
            (click)="$event.stopPropagation()">
            <img src="../../../../assets/images/notifications/notification_card_active_icon.png"
              alt="notification_card_active_icon" class="me-3" />
            <div>
              <div>
                <a class="link mt-2 mt-md-0 cursor-pointer" (click)="reRoute(item.user_id, item.type)">
                  {{ item.title }}
                </a>
              </div>
              <div class="text-muted">
                <a (click)="onCheckChangeAdminNotification(item)" class="link mt-2 mt-md-0 cursor-pointer">
                  <img src="../../../assets/images/check_box.png" class="me-1" alt="check_box icon" />Acknowledge
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-primary" routerLink="/portal/order-notifications">
          <button mat-button class="view_all">View All</button>
        </div>
      </mat-menu>


      <!-- notification block -->
      <button mat-icon-button class="mx-1 position-relative my-1 my-md-0" [matMenuTriggerFor]="menuNotification">
        <img src="assets/images/refill_renewal_notification.png" alt="refill_renewal_image" style="width: 25px;" />
        <span *ngIf="myData.length > 0" class="badge">{{ myData.length > 99 ? '99+' : myData.length }}
        </span>
      </button>
      <mat-menu #menuNotification="matMenu" class="mat-menu-notifications">
        <div class="p-2 bg-orange text-light">Renewal Refill Notifications</div>
        <div class="notifications">
          <div *ngFor="let item of myData; let i = index" class="d-flex align-items-center border-bottom p-2"
            (click)="$event.stopPropagation()">
            <img src="../../../../assets/images/notifications/notification_card_active_icon.png" class="me-3"
              alt="notification_card_active_icon" />
            <div>
              <div *ngIf="item.request_type != 'userToggleOnOff'">
                <a class="link mt-2 mt-md-0 cursor-pointer" [routerLink]="[
                    RouteConstants.RenewRefill.RenewRefillRequest.Route
                  ]" [queryParams]="{ request_type: item.request_type }">
                  {{ item.message }}
                </a>
              </div>
              <div *ngIf="item.request_type == 'userToggleOnOff'">
                <a class="link mt-2 mt-md-0 cursor-pointer" (click)="reRoute(item.user_id, item.tye)">
                  {{ item.message }}
                </a>
              </div>
              <div class="text-muted">
                <a (click)="onCheckChange(item)" class="link mt-2 mt-md-0 cursor-pointer">
                  <img src="../../../assets/images/check_box.png" class="me-1" alt="check_box icon" />Acknowledge
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center text-primary" routerLink="/portal/notifications">
          <button mat-button class="view_all">View All</button>
        </div>
      </mat-menu>

      <button mat-icon-button class="mx-1 position-relative my-1 my-md-0 domain-btn" *ngIf="tenant == 'sl' || tenant == 'pl' || tenant == 'qc'" (click)="openNewTaskModal()">
       <span class="material-icons">domain_verification_outlined</span>
      </button>

      <button mat-button [matMenuTriggerFor]="menu" class="px-2 ms-2">
        <div class="d-flex align-items-center">
          <div class="d-none d-md-block">
            {{ user?.name || user?.user_name || user?.first_name }}
          </div>
          <img src="assets/images/icons/small_avatar.png" class="mx-md-2 mx-1 profileImage" alt="avatar image" />
          <span class="material-icons text-dark"> keyboard_arrow_down </span>
        </div>
      </button>

      <mat-menu #menu="matMenu" class="logoutDropdown">
        <button mat-menu-item class="d-flex align-items-center" (click)="authService.logout()">
          <span class="material-icons-outlined me-2"> power_settings_new </span>
          Logout
        </button>
      </mat-menu>
    </div>

    </div>
  </div>
</div>
